import { render, staticRenderFns } from "./ExpedientesSection.vue?vue&type=template&id=12f8a5a4&scoped=true"
import script from "./ExpedientesSection.vue?vue&type=script&lang=js"
export * from "./ExpedientesSection.vue?vue&type=script&lang=js"
import style0 from "./ExpedientesSection.vue?vue&type=style&index=0&id=12f8a5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f8a5a4",
  null
  
)

export default component.exports